module.exports = __webpack_public_path__ + "static/img/zz.dfde27d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/zz.jpg
// module id = Sife
// module chunks = 1